// extracted by mini-css-extract-plugin
export default {"container":"DetailsModal_container__JHU-q","flexBox":"DetailsModal_flexBox__nEGwM","titleText":"DetailsModal_titleText__jup3v","valueText":"DetailsModal_valueText__cLB6y"};